export default __webpack_public_path__ + "static/media/newTeleLogoMini.7615eeda.svg";